var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoPassword = function SvgIcoPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ico_password")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Cashy_RegistrationFlow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_password",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,5 C11.5522847,5 12,5.44771525 12,6 L12,13 C12,13.5522847 11.5522847,14 11,14 L1,14 C0.44771525,14 0,13.5522847 0,13 L0,6 C0,5.44771525 0.44771525,5 1,5 L11,5 Z M10,7 L2,7 L2,12 L10,12 L10,7 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0 C8.209139,0 10,1.790861 10,4 L10,7 L2,7 L2,4 C2,1.790861 3.790861,0 6,0 Z M6,2 C4.9456382,2 4.08183488,2.81587779 4.00548574,3.85073766 L4,4 L4,5 L8,5 L8,4 C8,2.9456382 7.18412221,2.08183488 6.14926234,2.00548574 L6,2 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "*",
    points: "6.37196729 10.8751831 6.37196729 10.0930688 7.08088525 10.5519219 7.44488525 9.92192187 6.71496729 9.44906885 7.44488525 8.99908447 7.08088525 8.37608447 6.37196729 8.81206885 6.37196729 8 5.59496729 8 5.59496729 8.81206885 4.864 8.36908447 4.5 8.99908447 5.25196729 9.44906885 4.5 9.92192187 4.864 10.5449219 5.59496729 10.0860688 5.59496729 10.8751831"
  })))));
};
export default SvgIcoPassword;